/**
 * @desc 样品确认-作废
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductConfirmInvalidRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/invalid`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
